module.exports = __webpack_public_path__ + "img/Ens_sec2_02_FM.8634389c.jpg";